export const getCurrentStep = state => state.data.create.stepper.currentStep;
export const getFormData = state => state.data.create.form;
export const getCreateKey = state => state.data.create.key;
export const getCreateBatchNumber = state =>
  state.data.create.form?.batch?.batchNumber;
